// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { z } from 'zod';

const generateInvoicesResponseSchema = z.object({
  data: z.object({
    success: z.boolean(),
    invoicesCreated: z.number(),
    invoicesUpdated: z.number(),
    chargesSwept: z.number(),
  }),
  metadata: responseMetadataSchema,
});

type GenerateInvoicesResponse = z.infer<typeof generateInvoicesResponseSchema>;
export type GenerateInvoicesResult = GenerateInvoicesResponse['data'];

export async function generateInvoices(): Promise<GenerateInvoicesResponse> {
  const url = '/v1/billing/generate-invoices';
  const response = await api.post(url);

  return parseResponse(generateInvoicesResponseSchema, response.data, {
    schemaName: 'GenerateInvoices',
    endpoint: url,
  });
}
